import { createFileRoute } from "@tanstack/react-router";
import { ResearchMethodologyPage } from "@/pages/trust/TrustPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/research-methodology")({
  head: () =>
    seoHead({
      title: "Research Methodology",
      description: "Standards LeadXkids applies to research and aggregated data: anonymisation, consent, sample definition, age bands, dates and limitations.",
      canonical: "/research-methodology",
      pageType: "WebPage",
      jsonLd: [
        breadcrumbJsonLd([
          { name: "Home", url: "/" },
          { name: "Research methodology", url: "/research-methodology" },
        ]),
      ],
    }),
  component: ResearchMethodologyPage,
});
